import React from 'react';
import { Box, Heading, Page, PageContent, Tag } from 'grommet';
import { useLoaderData, useParams } from 'react-router-dom';
import { API, AppConstants, Utils, EventLog } from '@enrich/shared-lib';
import QueryString from 'qs';

export const CandidacySummary = () => {
    const candidacy = Utils.deepFlatten(useLoaderData());
    const { companySlug } = useParams();
    const { contact, job } = candidacy;
    const company = job.company;
    const { job_missed_match_deadline } = AppConstants.eventTypes;
    const visibleEvents = candidacy.events?.filter(
        (event) => event.type !== job_missed_match_deadline,
    );

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent gap="xsmall">
                <Heading level="2" fill="horizontal">
                    {contact.firstName} {contact.lastName} Candidacy for{' '}
                    {job.title} ({company.name})
                </Heading>

                <Box direction="row-responsive">
                    <Tag
                        background="enrich-blue"
                        name="Status "
                        value={Utils.convertEnumStringToLabel(candidacy.status)}
                    />
                </Box>

                <Box>
                    <Heading level="3">Recent Updates</Heading>
                    <Box
                        pad="medium"
                        elevation="large"
                        height={{ min: 'small', max: 'xxlarge' }}
                        overflow={{ vertical: 'auto', horizontal: 'auto' }}
                        fill={true}>
                        {visibleEvents?.length > 0 &&
                            visibleEvents.map((event) => (
                                <EventLog
                                    key={event.id}
                                    event={event}
                                    companySlug={companySlug}
                                />
                            ))}
                    </Box>
                </Box>
            </PageContent>
        </Page>
    );
};

export async function loader({ params }) {
    const query = QueryString.stringify({
        populate: {
            contact: true,
            job: { populate: { company: true } },
            events: {
                populate: {
                    candidacy: {
                        populate: {
                            job_locations: {
                                populate: ['location'],
                            },
                        },
                    },
                    contact: true,
                    job: true,
                },
                sort: 'createdAt:desc',
            },
        },
    });

    try {
        const response = await API.get(
            `/api/candidacies/${params.candidacyId}?${query}`,
        );

        return response.data.data;
    } catch (error) {
        console.log(error);
        return {};
    }
}
